import {translate} from "vue-gettext";

const {gettext: $gettext, pgettext: $pgettext} = translate;

export default {
    GLOBAL: 'GLOBAL',
    CONTRACT_MANAGER: 'CONTRACT_MANAGER',
    PICA_SERVICE: 'PICA_SERVICE',
    DJANGO: 'DJANGO',

    default() {
        return this.GLOBAL
    },

    label(scope, context = 'collaborators.scope') {
        const labels = {
            [this.GLOBAL]: $pgettext(context, 'Global'),
            [this.CONTRACT_MANAGER]: $pgettext(context, 'Contract Manager'),
            [this.PICA_SERVICE]: $pgettext(context, 'Pica Service'),
            [this.DJANGO]: $pgettext(context, 'Django')
        }
        return labels[scope] || scope
    },

    icon(scope) {
        const icons = {
            [this.GLOBAL]: 'cilGlobeAlt',
            [this.CONTRACT_MANAGER]: 'cilBriefcase',
            [this.PICA_SERVICE]: 'cilHome',
            [this.DJANGO]: 'cilSettings'
        }
        return icons[scope] || 'cilBadge'
    },

    color(scope) {
        const colors = {
            [this.GLOBAL]: 'primary',
            [this.CONTRACT_MANAGER]: 'info',
            [this.PICA_SERVICE]: 'success',
            [this.DJANGO]: 'warning'
        }
        return colors[scope] || 'secondary'
    },

    options(includeAll = false) {
        const opts = [
            {
                value: this.GLOBAL,
                label: $pgettext('collaborators.scope', 'Global'),
                icon: this.icon(this.GLOBAL)
            },
            {
                value: this.CONTRACT_MANAGER,
                label: $pgettext('collaborators.scope', 'Contract Manager'),
                icon: this.icon(this.CONTRACT_MANAGER)
            },
            {
                value: this.PICA_SERVICE,
                label: $pgettext('collaborators.scope', 'Pica Service'),
                icon: this.icon(this.PICA_SERVICE)
            },
            {
                value: this.DJANGO,
                label: $pgettext('collaborators.scope', 'Django'),
                icon: this.icon(this.DJANGO)
            }
        ]
        
        return opts
    },

    values() {
        return [this.GLOBAL, this.CONTRACT_MANAGER, this.PICA_SERVICE, this.DJANGO]
    }
}